// Konfiguracja wykresu klientów dla dashboardu handlowca

import { IWiseChartParameter } from 'components/wise';
import { ILoadDataParam } from 'plugins/api/types';

/**
 * Funkcja tworząca konfigurację parametrów dla wykresu
 * @param t - funkcja tłumaczeń
 */
export const getTraderDashboardChartParameters = (
  t: (key: string) => string
): IWiseChartParameter[] => {
  return [
    {
      type: 'date_range',
      label: t('Zakres dat'),
      field_symbol: 'date_range',
      default_value: ''
    }
  ];
};

/**
 * Parametry do pobierania danych dla wykresu
 */
export const traderDashboardChartLoadDataParams: ILoadDataParam = {
  get_url: '/sales-crm/clients/sales',
  params_list: null
};
